export default __webpack_public_path__ + "static/media/346.98943934.jpg";